import { CacheableDataObject } from 'models/CacheableDataObject';

export default class UserSettings extends CacheableDataObject {


}
UserSettings.prototype.dataLocationParsers = {
	random_challenges_from_groups: (settings, data) => {
		settings.random_challenges_from_groups = Number.parseInt(data.random_challenges_from_groups, 10);
	},
	matches_played_display_type: (settings, data) => {
		settings.matches_played_display_type = Number.parseInt(data.matches_played_display_type, 10);
	},
};